import {Component, input, output} from '@angular/core';
import {TextInput} from '../../../../components/text-input/text-input';
import {TranslatePipe} from '@ngx-translate/core';
import {UserDropdown} from '../../../../components/user-dropdown/user-dropdown';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ElciaDatePicker} from '../../../../components/date-picker/date-picker';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {ChildTodoModelForm} from "../../models/child-todo-model-form";
import {CheckBox} from '../../../../components/check-box/check-box';

@Component({
  selector: 'elcia-sub-todo-form',
  imports: [
    TextInput,
    TranslatePipe,
    UserDropdown,
    ReactiveFormsModule,
    ElciaDatePicker,
    ElciaButton,
    CheckBox,
  ],
  templateUrl: './sub-todo-form.html',
  styleUrl: './sub-todo-form.scss',
})
export class SubTodoForm {
  control = input.required<FormGroup<ChildTodoModelForm>>();
  onRemove = output<void>();

  protected remove() {
    this.onRemove.emit();
  }
}
